export default "/kiban/_next/static/images/wireBonding-3a9b37c9104bf40343ef404779649664.png";